<template>
  <div>
    <!-- 桐花預測專案結束，只呈現單一張照片 -->
    <template v-if="display_one_photo || slideshow_data.length == 0">
      <b-img
        :src="getFieldImage"
        class="fade-in"
        fluid-grow
        :alt="`${field_name} 照片`"
      ></b-img>
    </template>

    <!--桐花預測專案進行中，以 slider 播放縮時攝影照片 -->
    <template v-else>
      <div class="home-slider">
        <div class="carousel-style">
          <b-carousel
            id="carousel-1"
            v-model="slide"
            :interval="5000"
            :controls="true"
            :fade="true"
            indicators
            background="#0d0d0d"
            img-width="1024"
            img-height="480"
            style="text-shadow: 1px 1px 2px #333; z-index: 0"
            @sliding-start="onSlideStart"
            @sliding-end="onSlideEnd"
          >
            <!-- Text slides with image -->
            <!-- <b-carousel-slide
                        caption="First slide"
                        text="Nulla vitae elit libero, a pharetra augue mollis interdum."
                        img-src="https://picsum.photos/1024/480/?image=52"
                    ></b-carousel-slide> -->

            <!-- Slides with custom text -->
            <!-- <b-carousel-slide img-src="https://picsum.photos/1024/480/?image=54">
                        <h1>Hello world!</h1>
                    </b-carousel-slide> -->

            <!-- Slides with image only -->
            <!-- <b-carousel-slide img-src="https://picsum.photos/1024/480/?image=58"></b-carousel-slide> -->

            <!-- Slide with blank fluid image to maintain slide aspect ratio -->
            <!-- <b-carousel-slide caption="Blank Image" img-blank img-alt="Blank image">
                        <p>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse eros felis, tincidunt
                        a tincidunt eget, convallis vel est. Ut pellentesque ut lacus vel interdum.
                        </p>
                    </b-carousel-slide> -->

            <b-carousel-slide
              v-for="(data, idx) in slideshow_data"
              :key="idx"
              :caption="data.caption"
              :img-src="data.img"
            >
              <template #img>
                <div class="slide-img" :style="imgCover(data.img)"></div>
              </template>

              <p v-if="data.description != undefined" class="slide-description">
                {{ data.description }}
              </p>
            </b-carousel-slide>
          </b-carousel>

          <!-- <div class="title-in-slider">
                    <div>嘉義縣阿里山咖啡產業平台</div>
                </div> -->
        </div>

        <!-- <p class="mt-4"> -->
        <!-- Slide #: {{ slide }}<br>
                Sliding: {{ sliding }} -->
        <!-- </p> -->
      </div>
    </template>
  </div>
</template>

<script>
import DateTools from "@/tools/date";

export default {
  props: {
    //NOTE - 是否只顯示單一張照片（不使用 slider）
    display_one_photo: {
      type: Boolean,
      default: false,
    },
    field_id: {
      type: [String, Number],
      required: true,
    },
    field_name: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      loading: false,
      slide: 0,
      sliding: null,
      slideshow_data: [],
    };
  },
  mounted() {
    this.get_Data();
  },
  computed: {
    getFieldImage() {
      return `https://storage.googleapis.com/tung-photo-storage/photos/field${this.field_id}/field${this.field_id}-cover.jpg`;
    },
  },
  watch: {
    field_id() {
      this.get_Data();
    },
  },
  methods: {
    onSlideStart(slide) {
      this.sliding = true;
    },

    onSlideEnd(slide) {
      this.sliding = false;
    },

    imgCover(url, imgSize = "cover") {
      return {
        backgroundImage: "url(" + url + ")",
        backgroundSize: imgSize,
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      };
    },

    // 取得縮時照片
    get_Data() {
      this.loading = true;
      const options = {
        method: "GET",
        url: this.$config.getAPI_URL("Field_Photos", {
          fieldID: this.field_id,
        }),
      };
      this.$http(options)
        .then((res) => {
          // console.log( res.data )
          let _photos = [];

          if (res.data.photos != undefined && res.data.photos.length > 0) {
            res.data.photos.forEach((_item) => {
              _photos.push({
                img: _item.file_path,
                description: DateTools.Get_DateTimeZone(
                  _item.log_time,
                  "Asia/Taipei",
                  "YYYY-MM-DD HH:mm"
                ),
              });
            });
          }

          this.slideshow_data = _photos;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss">
.home-slider {
  .carousel-control-next-icon,
  .carousel-control-prev-icon {
    width: 40px;
    height: 40px;
    margin-top: -20px;

    @media (max-width: 768px) {
      width: 30px;
      height: 30px;
      margin-top: -15px;
    }
  }

  .carousel-style {
    //     .carousel.slide,
    //     .carousel-inner,
    //     .carousel-item,
    //     img.img-fluid
    //     {
    //          @media only screen and (min-width: 900px)
    //         {
    //             border-radius: 0px 0px 5px 5px !important;
    //         }
    //     }
    @media (max-width: 768px) {
      margin-bottom: 30px !important;
    }
  }

  .carousel-indicators li {
    // 將按鈕改成圓形
    width: 13px !important;
    height: 13px !important;
    margin: 0px 6px;
    border-radius: 100% !important;
    // background-color: rgba(133, 209, 131, 0.6);

    @media only screen and (max-width: 500px) {
      width: 8px;
      height: 8px;
      margin: 0px 4px;
    }
  }
  // .carousel-indicators li.active
  // {
  //     background-color: #aae228;
  // }

  .title-in-slider {
    position: absolute;
    width: 100%;
    top: 140px;
    // margin-top: -280px !important;
    text-align: center;
    color: white;
    font-size: 2.2rem;

    @media (max-width: 768px) {
      top: 120px;
      font-size: 2.2rem;
    }

    @media (max-width: 500px) {
      top: 120px;
      font-size: 1.4rem;
    }
  }

  .search-tool-in-slider {
    position: absolute;
    width: 100%;
    margin-top: -180px !important;

    @media (max-width: 768px) {
      margin-top: 0px !important;
    }
  }

  .carousel {
    border-radius: 6px 6px 0px 0px;
  }

  .slide-img {
    width: 100%;
    height: 700px;
    // opacity: 0.8;
    filter: contrast(1.2);

    @media (max-width: 1024px) {
      height: 500px;
    }
    @media (max-width: 768px) {
      height: 300px;
    }
    @media (max-width: 450px) {
      height: 220px;
    }
  }

  .slide-description {
    font-weight: 500;
    text-shadow: 2px 2px 5px rgb(0, 0, 0);
  }
}
</style>
